exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".padding-top-bottom[data-v-59705e78]{padding-top:1.5rem;padding-bottom:1.5rem}footer[data-v-59705e78]{height:120px;padding-top:1rem;padding-bottom:1rem;background:#262626}footer p[data-v-59705e78]{color:#afafaf;margin-bottom:0;font-size:.7rem}@media (min-width:576px){footer p[data-v-59705e78]{font-size:.8rem}}footer p span[data-v-59705e78]{display:block}@media (min-width:576px){footer p span[data-v-59705e78]{display:inline-block}}footer .titulo-dependencia-footer[data-v-59705e78]{font-weight:600;text-transform:uppercase;font-size:.75rem}@media (min-width:576px){footer .titulo-dependencia-footer[data-v-59705e78]{font-size:.85rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59705e78","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 278
// module chunks = 0